import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  background: #fff;
  border: 1px solid #ccc;
  padding: 0.5rem;
  border-radius: 0.25rem;
  font-size: 1rem;
  color: #666;
  white-space: pre-wrap;
`;

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return <Wrapper>{payload[0].payload.tooltip}</Wrapper>;
  }
  return null;
};

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
};

CustomTooltip.displayName = 'CustomTooltip';

export default CustomTooltip;
